module.exports = __webpack_public_path__ + "b5d7417a0f673a0ea16a24fb42d11c5e.svg";